import _ from 'lodash'
import d3 from 'd3'

const debug = true
const earlyArriveCompensation = false

// const wsStatus = ['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'];

export default class GenericChart {
  constructor (el, _config) {
    var vm = this

    var tickConfig = {
      vmic_y: [0, 200, 400, 600, 800, 1000],
      qura_y: [0, 10, 20, 30, 40, 50],
      // qura_y: [0, 5, 10, 15, 20, 25],
      emg_y: [-200, -100, 0, 100, 200],
      vmic_domain: [0, 1000],
      qura_domain: [0, 50],
      emg_domain: [-200, 200],
      // emg_y: [-200, -100, 0, 100, 200],
      verticalTicks: false
    }

    // initialize config
    var config = _config || {
      width: 800,
      height: 384,
      margin: { top: 5, bottom: 16, left: 75, right: 0 }
      // tickEvery: 1
    } // put all of them here and consider merging !!

    config.orientation = config.orientation || 'horizontal' // horizontal default
    config.chartType = config.chartType || 'static' // horizontal default

    config.tickConfig = Object.assign({}, tickConfig, config.tickConfig)
    config.axisLabels = config.axisLabels || 'enabled'

    config.visiblePoints = (config.totalTime / config.tickInterval) + 1
    config.visiblePoints2 = (config.totalTime / config.tickInterval) * 10 + 1
    config.allPoints = config.visiblePoints + 1 + config.invisible_points * 2
    config.allPoints2 = config.visiblePoints2 + 10

    // console.log('allPoints', config.allPoints, 'allPoints2', config.allPoints2)

    config.invisibleHeadTime = config.invisible_points * config.tickInterval
    config.invisibleTailTime = config.invisibleHeadTime + config.tickInterval

    config.emgEnabled = true

    vm.el = el
    vm.config = config
    vm.$t = config.translation
  }

  getHistory () {
    return this.chart.history
  }

  stop (cb) {
    var vm = this

    vm.disabled = 1

    console.log('Stopping chart...')

    vm.chart.pathGroup
      .transition()
      .duration(0)
      .each('end', cb)
  }

  rescaleQura (domNstep) {
    var vm = this
    var dom = [domNstep[0], domNstep[1]]
    vm.config.tickConfig.qura_domain = dom
    vm.chart.y2 = d3.scale.linear().domain(dom).range([vm.chart.oneSegment * 2, vm.chart.oneSegment])
    var tickValues = d3.range(vm.chart.y2.domain()[0], vm.chart.y2.domain()[1] + 1, domNstep[2])
    vm.chart.svg
      .select('.axis.axis--y2')
      .call(d3.svg.axis().scale(vm.chart.y2).orient('left').tickValues(tickValues).tickSize(-vm.chart.chartWidth)) // will change in v4 [axisLeft]
  }

  rescaleEmg (dom) {
    var vm = this
    vm.config.tickConfig.emg_domain = dom
    vm.chart.y3 = d3.scale.linear().domain(dom).range([vm.chart.oneSegment * 3, vm.chart.oneSegment * 2])
    vm.chart.svg
      .select('.axis.axis--y3')
      .call(d3.svg.axis().scale(vm.chart.y3).orient('left')./* tickValues(vm.config.tickConfig.emg_y). */tickSize(-vm.chart.chartWidth).tickFormat((x) => x >= 0 ? x : '')) // will change in v4 [axisLeft]
  }

  emgEnable (enable, disableUroflow) {
    var vm = this
    vm.config.emgEnabled = enable

    var oneSegment
    var emgTickValues = vm.config.tickConfig.emg_y

    if (enable) { oneSegment = vm.chart.chartHeight / 3.0 } else { oneSegment = vm.chart.chartHeight / 2.0; emgTickValues = [] }

    if (disableUroflow) {
      oneSegment = vm.chart.chartHeight

      vm.chart.y = d3.scale.linear().domain(vm.config.tickConfig.vmic_domain).range([oneSegment * 3, oneSegment * 2]) // will change in v4 [scaleLinear]
      vm.chart.y2 = d3.scale.linear().domain(vm.config.tickConfig.qura_domain).range([oneSegment * 2, oneSegment]) // will change in v4 [scaleLinear]
      vm.chart.y3 = d3.scale.linear().domain(vm.config.tickConfig.emg_domain).range([oneSegment, 0]) // will change in v4 [scaleLinear]

      vm.chart.yAxis1.select('.txt1').attr('transform', 'translate(' + (-12 - vm.config.margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 2)) + ')')
      vm.chart.yAxis2.select('.txt2').attr('transform', 'translate(' + (-12 - vm.config.margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 1)) + ')')
      vm.chart.yAxis3.select('.txt3').attr('transform', 'translate(' + (-12 - vm.config.margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 0)) + ')')

      vm.chart.defs.select('#clip1-rect').attr('y', oneSegment * 2).attr('height', oneSegment + vm.chart.clipLineMargin)
      vm.chart.svg.select('#clipPath1').attr('y', oneSegment * 2).attr('height', oneSegment + vm.chart.clipLineMargin)

      vm.chart.defs.select('#clip2-rect').attr('y', oneSegment * 1).attr('height', oneSegment + vm.chart.clipLineMargin)
      vm.chart.svg.select('#clipPath2').attr('y', oneSegment * 1).attr('height', oneSegment + vm.chart.clipLineMargin)

      vm.chart.defs.select('#clip3-rect').attr('y', oneSegment * 0).attr('height', oneSegment)
      vm.chart.svg.select('#clipPath3').attr('y', oneSegment * 0).attr('height', oneSegment)
    } else {
      vm.chart.y = d3.scale.linear().domain(vm.config.tickConfig.vmic_domain).range([oneSegment, 0]) // will change in v4 [scaleLinear]
      vm.chart.y2 = d3.scale.linear().domain(vm.config.tickConfig.qura_domain).range([oneSegment * 2, oneSegment]) // will change in v4 [scaleLinear]
      vm.chart.y3 = d3.scale.linear().domain(vm.config.tickConfig.emg_domain).range([oneSegment * 3, oneSegment * 2]) // will change in v4 [scaleLinear]

      vm.chart.yAxis1.select('.txt1').attr('transform', 'translate(' + (-12 - vm.config.margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 0)) + ')')
      vm.chart.yAxis2.select('.txt2').attr('transform', 'translate(' + (-12 - vm.config.margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 1)) + ')')
      vm.chart.yAxis3.select('.txt3').attr('transform', 'translate(' + (-12 - vm.config.margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 2)) + ')')

      vm.chart.defs.select('#clip1-rect').attr('y', oneSegment * 0).attr('height', oneSegment + vm.chart.clipLineMargin)
      vm.chart.svg.select('#clipPath1').attr('y', oneSegment * 0).attr('height', oneSegment + vm.chart.clipLineMargin)

      vm.chart.defs.select('#clip2-rect').attr('y', oneSegment * 1).attr('height', oneSegment + vm.chart.clipLineMargin)
      vm.chart.svg.select('#clipPath2').attr('y', oneSegment * 1).attr('height', oneSegment + vm.chart.clipLineMargin)

      vm.chart.defs.select('#clip3-rect').attr('y', oneSegment * 2).attr('height', oneSegment)
      vm.chart.svg.select('#clipPath3').attr('y', oneSegment * 2).attr('height', oneSegment)
    }

    vm.chart.oneSegment = oneSegment

    vm.chart.svg
      .select('.axis.axis--y1')
      .call(d3.svg.axis().scale(vm.chart.y).orient('left').tickValues(vm.config.tickConfig.vmic_y).tickSize(-vm.chart.chartWidth)) // will change in v4 [axisLeft]

    vm.chart.svg
      .select('.axis.axis--y2')
      .call(d3.svg.axis().scale(vm.chart.y2).orient('left').tickValues(vm.config.tickConfig.qura_y).tickSize(-vm.chart.chartWidth)) // will change in v4 [axisLeft]

    vm.chart.svg
      .select('.axis.axis--y3')
      .call(d3.svg.axis().scale(vm.chart.y3).orient('left').tickValues(emgTickValues).tickSize(-vm.chart.chartWidth).tickFormat((x) => x >= 0 ? x : '')) // will change in v4 [axisLeft]

    if (vm.config.chartType === 'static') {
      vm.chart.path1
        .attr('d', vm.chart.line1)

      vm.chart.path2
        .attr('d', vm.chart.line2)

      vm.chart.path3
        .attr('d', vm.chart.line3)

      vm.chart.path3_area
        .attr('d', vm.chart.area3)
    }
  }

  initDrawing (data1, data2, data3, scaleConfig, emgScaleConfig) {
    var vm = this

    vm.chart = { // bu tanimlama constructor'a konursa, vuejs getter/setter ekliyor vs asagidaki vm.chart.pathGroup.append satirinda hata veriyor. belki butun init islemleri, reactive olmayacaksa burada yapilmali ?!!
      data1: [],
      data2: [],
      data3: [],
      history: undefined,
      pathGroup: undefined,
      path1: undefined,
      path2: undefined,
      path3: undefined,
      line1: undefined,
      line2: undefined,
      line3: undefined,
      x: undefined,
      xAxis: undefined,
      isTicking: false,
      cleftTickWidth: 0,
      leftTickWidth: 0,
      tickWidth: 0,
      tickInterval: 1000,
      tickInterval2: 100,
      delayedTicks: 0
    }

    // console.log(data1.length, data2.length, data3.length)
    if (data1.length !== data2.length) { console.log('Mismatch data size (w, s)', data1.length, data2.length) }
    if (data1.length && data3.length && data3.length !== ((data1.length - 1) * 10 + 1)) { console.log('Mismatch data size (w, e)', data1.length, data3.length) }

    vm.chart.clipLineMargin = vm.config.lineStrokeWidth * 1.0

    // console.groupCollapsed()

    // console.log(data1, data2, data3)

    var config = vm.config
    if (data1.length) {
      config.lastTime = data1[data1.length - 1][0].getTime()
    } else {
      config.lastTime = data3[data3.length - 1][0].getTime()
    }
    config.visibleDomain = [(config.lastTime - config.invisibleHeadTime) - config.totalTime, config.lastTime - config.invisibleHeadTime]
    // console.log(config.lastTime, config.invisibleHeadTime, config.totalTime, config.lastTime, config.invisibleHeadTime)

    if (data3 === undefined) { data3 = [] }

    if (config.chartType === 'dynamic') {
      console.log('Cropping data as this is a dynamic chart. (got last ' + config.allPoints + ' points)')

      data1 = _.takeRight(data1, config.allPoints)
      data2 = _.takeRight(data2, config.allPoints)
      data3 = _.takeRight(data3, config.allPoints2)
    }

    vm.data1 = data1
    vm.data2 = data2
    vm.data3 = data3

    var margin = config.margin

    margin.horizontal = margin.left + margin.right
    margin.vertical = margin.top + margin.bottom

    var chartWidth = config.width - (margin.left + margin.right)
    var chartHeight = config.height - (margin.top + margin.bottom)
    vm.chart.chartHeight = chartHeight
    vm.chart.chartWidth = chartWidth

    var verticalTickHeight = config.tickConfig.verticalTicks ? -chartHeight : 0

    if (config.chartType === 'dynamic') { console.log('Total duration:' + config.visiblePoints * config.tickInterval + ' (every two points can draw ' + config.tickInterval + ' of duration)') }

    vm.chart.config = config

    // if (config && config.chartSize) { chartSize = config.chartSize }

    vm.chart.data1 = vm.data1
    vm.chart.data2 = vm.data2
    vm.chart.data3 = vm.data3
    vm.chart.tickInterval = vm.config.tickInterval

    // vm.chart.history = [_.cloneDeep(vm.data1), _.cloneDeep(vm.data2), _.cloneDeep(vm.data3)]

    d3.select(vm.el).selectAll('*').remove()

    var topTransform = {

      vertical: 'translate(' + (config.height - margin.top) + ', ' + margin.left + ') rotate(90, 0, 0)',
      horizontal: 'translate(' + margin.left + ',' + margin.top + ')'

    }

    var rootSvg = d3.select(vm.el)

    // var scopedId = '';
    //
    // for (var i = 0; i < vm.el.attributes.length; i++) {
    //   var attrib = vm.el.attributes[i];
    //   if (attrib.specified && !attrib.value) { scopedId = attrib.name; break; }
    // }

    // console.log( _.find(vm.el.attributes, function (a, b, c) { console.log(a); }));

    if (config.orientation === 'vertical') {
      rootSvg
        .attr('height', chartWidth + margin.horizontal)
        .attr('width', chartHeight + margin.vertical)
    } else {
      rootSvg
        .attr('width', chartWidth + margin.horizontal)
        .attr('height', chartHeight + margin.vertical)
    }

    var oneSegment

    if (vm.config.emgEnabled) { oneSegment = chartHeight / 3.0 } else { oneSegment = chartHeight / 2.0 }
    vm.chart.oneSegment = oneSegment

    if (scaleConfig && scaleConfig.qura) {
      let quraDomain = [scaleConfig.qura[0], scaleConfig.qura[1]]
      let quraStep = scaleConfig.qura[2]
      vm.config.tickConfig.qura_domain = quraDomain
      vm.chart.y2 = d3.scale.linear().domain(quraDomain).range([vm.chart.oneSegment * 2, vm.chart.oneSegment])
      vm.config.tickConfig.qura_y = d3.range(vm.chart.y2.domain()[0], vm.chart.y2.domain()[1] + 1, quraStep)
    }

    if (emgScaleConfig && emgScaleConfig.uV) {
      let domain = [emgScaleConfig.uV[0], emgScaleConfig.uV[1]]
      let step = emgScaleConfig.uV[2]

      vm.config.tickConfig.emg_domain = domain
      vm.chart.y3 = d3.scale.linear().domain(domain).range([vm.chart.oneSegment * 3, vm.chart.oneSegment * 2])
      vm.config.tickConfig.emg_y = d3.range(vm.chart.y3.domain()[0], vm.chart.y3.domain()[1] + 1, step)
    }

    var debugAppend = function (elementId, el, targetElement, fill, _x, _y) {
      if (!debug) return

      var x = _x || 0
      // var y = _y || 0

      targetElement
        .append('rect')
        .attr('class', 'svg-debug')
        .attr('id', elementId)
        .attr('x', el.attr('x') + x)
        .attr('y', el.attr('y'))
        .attr('width', el.attr('width'))
        .attr('height', el.attr('height'))
        .attr('fill', fill)
        .style('visibility', 'hidden')
    }

    debugAppend('rootSvg', rootSvg, rootSvg, 'rgba(250, 255, 0, 0.21)')

    var svg = rootSvg.append('g')
      .attr('transform', topTransform[config.orientation])
    vm.chart.svg = svg

    if (config.chartType === 'static') {
      if (data1.length) {
        vm.chart.x = d3.time.scale().domain([0, (vm.data1.length - 1) * config.tickInterval]).range([0, chartWidth]) // will change in v4 [scaleTime]
      } else {
        vm.chart.x = d3.time.scale().domain([0, (vm.data3.length - 1) * (config.tickInterval / 10)]).range([0, chartWidth]) // will change in v4 [scaleTime]
      }
    } else {
      vm.chart.x = d3.time.scale().domain([-config.totalTime, 0]).range([0, chartWidth]) // will change in v4 [scaleTime]

      // calculate tickWidth and expand domain and range for one tick. if there is no non_visible points, at least one TICK LABEL OF X-AXIS will be ready in advance to use while animating
      vm.chart.tickWidth = vm.chart.x(vm.chart.tickInterval) - vm.chart.x(0)

      vm.chart.x = d3.time.scale().domain([config.visibleDomain[0], config.visibleDomain[1] + vm.chart.tickInterval]).range([0, chartWidth + vm.chart.tickWidth]) // will change in v4 [scaleTime]
    }

    var oneSecondInPixels = Math.abs(Math.ceil(vm.chart.x(config.visibleDomain[0] + 1000) - vm.chart.x(config.visibleDomain[0])))

    vm.chart.defs = rootSvg.append('defs')

    var clipPath = vm.chart.defs
      .append('clipPath')
      .attr('id', 'clip')
      .append('rect') // chart area
      .attr('xcomment', 'if you are hovering this element in dev tools, look for comments in the source code to know what happens !!!')
    // .attr('x', -vm.chart.clipLineMargin)
      .attr('y', -margin.top)
      .attr('width', chartWidth + vm.chart.clipLineMargin * 2)
      .attr('height', chartHeight + margin.vertical)
      .attr('transform', 'translate(' + (-vm.chart.clipLineMargin) + ', 0)')

    var clipPath1 = vm.chart.defs
      .append('clipPath')
      .attr('id', 'clip1')
      .append('rect') // chart area
      .attr('id', 'clip1-rect')
      .attr('xcomment', 'if you are hovering this element in dev tools, look for comments in the source code to know what happens !!!')
      .attr('width', chartWidth + oneSecondInPixels)
      .attr('height', vm.chart.oneSegment + vm.chart.clipLineMargin)

    var clipPath2 = vm.chart.defs
      .append('clipPath')
      .attr('id', 'clip2')
      .append('rect') // chart area
      .attr('id', 'clip2-rect')
      .attr('xcomment', 'if you are hovering this element in dev tools, look for comments in the source code to know what happens !!!')
      .attr('y', vm.chart.oneSegment * 1)
      .attr('width', chartWidth + oneSecondInPixels)
      .attr('height', vm.chart.oneSegment + vm.chart.clipLineMargin)

    var clipPath3 = vm.chart.defs
      .append('clipPath')
      .attr('id', 'clip3')
      .append('rect') // chart area
      .attr('id', 'clip3-rect')
      .attr('xcomment', 'if you are hovering this element in dev tools, look for comments in the source code to know what happens !!!')
      .attr('y', vm.chart.oneSegment * 2)
      .attr('width', chartWidth + oneSecondInPixels)
      .attr('height', vm.chart.oneSegment) // eksen ortada olduğundan  + vm.chart.clipLineMargin gereksiz
      /*
            'clipped-content' will be drawn in 'svg' but clipPath in 'rootSvg' (in order to cover top margin)
            while using clipPath definition, 'clipped-content' automatically use clipPath starting from its own margins
            so, while defining clipPath we started it from -topMargin to cover top area above.
                while drawing debug rectangle we added margins manually below
      */
    debugAppend('clipPath', clipPath, rootSvg, 'rgba(100, 0, 0, 0.25)', margin.left)

    /* ///// y axes \\\\\ */

    vm.chart.y = d3.scale.linear().domain(config.tickConfig.vmic_domain).range([oneSegment, 0]) // will change in v4 [scaleLinear]
    vm.chart.y2 = d3.scale.linear().domain(config.tickConfig.qura_domain).range([oneSegment * 2, oneSegment]) // will change in v4 [scaleLinear]
    vm.chart.y3 = d3.scale.linear().domain(config.tickConfig.emg_domain).range([oneSegment * 3, oneSegment * 2]) // will change in v4 [scaleLinear]

    vm.chart.yAxis1 = svg
      .append('g')
      .attr('class', 'axis axis--y1')
      .call(d3.svg.axis().scale(vm.chart.y).orient('left').tickValues(vm.config.tickConfig.vmic_y).tickSize(-chartWidth)) // will change in v4 [axisLeft]

    vm.chart.yAxis2 = svg
      .append('g')
      .attr('class', 'axis axis--y2')
      .call(d3.svg.axis().scale(vm.chart.y2).orient('left').tickValues(vm.config.tickConfig.qura_y).tickSize(-chartWidth)) // will change in v4 [axisLeft]

    vm.chart.yAxis3 = svg
      .append('g')
      .attr('class', 'axis axis--y3')
      .call(d3.svg.axis().scale(vm.chart.y3).orient('left').tickValues(vm.config.tickConfig.emg_y).tickSize(-chartWidth).tickFormat((x) => x >= 0 ? x : '')) // will change in v4 [axisLeft]

    if (config.axisLabels === 'enabled') {
      var txt1 = vm.chart.yAxis1.append('g').attr('class', 'txt1').attr('transform', 'translate(' + (-12 - margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 0)) + ')').append('text').attr('x', 0).attr('y', 0)
      txt1.append('tspan').style('text-anchor', 'middle').attr('x', '0').attr('dy', '-1.2em').text(vm.$t('device_ui.vmic'))
      txt1.append('tspan').style('text-anchor', 'middle').attr('x', '0').attr('dy', '1.2em').text('(ml)')
      vm.chart.liveVmic = txt1.append('tspan').style('text-anchor', 'middle').style('font-size', '13px').attr('x', '0').attr('dy', '1.6em').text('')

      var txt2 = vm.chart.yAxis2.append('g').attr('class', 'txt2').attr('transform', 'translate(' + (-12 - margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 1)) + ')').append('text').attr('x', 0).attr('y', 0)
      txt2.append('tspan').style('text-anchor', 'middle').attr('x', '0').attr('dy', '-1.2em').text(vm.$t('device_ui.qura'))
      txt2.append('tspan').style('text-anchor', 'middle').attr('x', '0').attr('dy', '1.2em').text('(ml/s)')
      vm.chart.liveQura = txt2.append('tspan').style('text-anchor', 'middle').style('font-size', '13px').attr('x', '0').attr('dy', '1.6em').text('')

      var txt3 = vm.chart.yAxis3.append('g').attr('class', 'txt3').attr('transform', 'translate(' + (-12 - margin.left / 2) + ',' + ((oneSegment / 2) + (oneSegment * 2)) + ')').append('text').attr('x', 0).attr('y', 0)
      txt3.append('tspan').style('text-anchor', 'middle').attr('x', '0').attr('dy', '-1.2em').text('Emg')
      txt3.append('tspan').style('text-anchor', 'middle').attr('x', '0').attr('dy', '1.2em').text('(μV)')
      vm.chart.liveEmg = txt3.append('tspan').style('text-anchor', 'middle').style('font-size', '13px').attr('x', '0').attr('dy', '1.6em').text('')
    }

    /* \\\\\ y axes ///// */

    var interpolation = vm.chart.config.interpolation

    vm.chart.line1 = d3.svg.line()
      .interpolate(interpolation)
      .x(function (d, i) { return vm.chart.x(d[0]) })
      .y(function (d, i) { return vm.chart.y(d[1]) })

    vm.chart.line2 = d3.svg.line()
      .interpolate(interpolation)
      .x(function (d, i) { return vm.chart.x(d[0]) })
      .y(function (d, i) { return vm.chart.y2(d[1]) })

    vm.chart.line3 = d3.svg.line()
    // .interpolate(interpolation)
      .x(function (d, i) { return vm.chart.x(d[0]) })
      .y(function (d, i) { return vm.chart.y3(d[1]) })

    vm.chart.area3 = d3.svg.area()
      .x(function (d, i) { return vm.chart.x(d[0]) })
      .y0(function (d) { return vm.chart.y3(-d[1]) }) // lower limit of area
      .y1(function (d) { return vm.chart.y3(d[1]) }) // upper limit of area

    var pathContainer = svg
      .append('g')

    pathContainer
      .attr('clip-path', 'url(#clip)')
      .attr('id', 'clipped-content')

    // if(debug) vm.toggleCP();

    vm.chart.pathGroup = pathContainer.append('g').attr('T', 1) // T is for early-arrive-compensation...

    debugAppend('clipPath1', clipPath1, vm.chart.pathGroup, 'rgba(255, 0, 0, 0.25)')
    debugAppend('clipPath2', clipPath2, vm.chart.pathGroup, 'rgba(0, 255, 0, 0.25)')
    debugAppend('clipPath3', clipPath3, vm.chart.pathGroup, 'rgba(0, 0, 0, 0.25)')

    var formatTime = d3.time.format('%M:%S')
    var formatMinutes = function (d) { var dt = new Date(d); if (dt.getTime() < 0) { return null } else { return formatTime(new Date(d)) } }

    // formatMinutes = '%M:%S';

    vm.chart.x.axis = d3.svg.axis().scale(vm.chart.x).tickSize(verticalTickHeight).orient('bottom').tickFormat(formatMinutes).ticks(6)
    // .call(d3.svg.axis().scale(vm.chart.y).orient('left').tickValues(vm.config.tickConfig.vmic_y).tickSize(-vm.chart.chartWidth)) // will change in v4 [axisLeft]

    if (vm.config.tickEvery) { vm.chart.x.axis = vm.chart.x.axis.ticks(d3.time.seconds, vm.config.tickEvery) }

    // console.dir(vm.config)

    vm.chart.xAxis = vm.chart.pathGroup.append('g')
      .attr('class', 'axis axis--x')
      .attr('transform', 'translate(0,' + (chartHeight /* + chartSize.margin.t + chartSize.margin.b */) + ')')
      .call(vm.chart.x.axis) // will change in v4 [axisBottom]

    // hacky way to add right line of square around chart
    var firstVertical = vm.chart.pathGroup.select('.axis--x > .tick:first-child > line').node()
    var lastVertical = d3.select(firstVertical.parentNode.insertBefore(firstVertical.cloneNode(true), firstVertical.nextSibling))
    lastVertical.attr('transform', 'translate(' + (chartWidth) + ',0)')

    // /mat MAY SLOW DOWN !!!*/

    vm.chart.path1 = vm.chart.pathGroup.append('path')
      .datum(vm.chart.data1)
      .attr('class', 'line1')
      .attr('clip-path', 'url(#clip1)')
      .attr('d', vm.chart.line1)

    vm.chart.path2 = vm.chart.pathGroup.append('path')
      .datum(vm.chart.data2)
      .attr('class', 'line2')
      .attr('clip-path', 'url(#clip2)')
      .attr('d', vm.chart.line2)

    vm.chart.path3 = vm.chart.pathGroup.append('path')
      .datum(vm.chart.data3)
      .attr('class', 'line3')
      .attr('clip-path', 'url(#clip3)')
      .attr('d', vm.chart.line3)

    vm.chart.path3_area = vm.chart.pathGroup.append('path')
      .datum(vm.chart.data3)
      .attr('class', 'area')
      .attr('clip-path', 'url(#clip3)')
      .attr('d', vm.chart.area3)

    // chart.pathGroup
    //       .attr("transform", "translate(" + (-chart.tickWidth) + "," + 0 + ")")

    // console.groupEnd()

    if (data1.length) {
      vm.prevTime = vm.chart.data1[vm.chart.data1.length - 1][0].getTime()
    } else {
      vm.prevTime = vm.chart.data3[vm.chart.data3.length - 1][0].getTime()
    }
    vm.tick2feed = 0

    // if (config.chartType === 'static') { console.log('STATIC_CHART_LOADED') }
  } // initDrawing

  tick (w) {
    var vm = this

    if (vm.config.chartType === 'static') { console.log('static chart could not be ticked.'); return 0 }

    if (w === undefined) {
      let _e = Array.from({length: 10}, () => Math.floor(Math.random() * 300))
      let e = _e.map(x => [x])
      w = [Math.random() * 1500, Math.random() * 75, e]
    } // JUST FOR TESTING

    var emg = w[2]

    // vm.chart.liveVmic.text(parseInt(w[0], 10));
    // vm.chart.liveQura.text(parseInt(w[1], 10));
    vm.chart.liveVmic.text(w[0].toFixed(0))
    vm.chart.liveQura.text(w[1].toFixed(0))

    if (vm.config.emgEnabled && emg.length) { vm.chart.liveEmg.text(emg[0][0].toFixed(0)) }

    var doShifting = function () {
      var lastTime

      if (vm.chart.data1.length) { lastTime = new Date(vm.chart.data1[vm.chart.data1.length - 1][0].getTime() + vm.chart.tickInterval) } else { lastTime = new Date(0) }

      vm.chart.data1.push([lastTime, w[0]])
      vm.chart.data2.push([lastTime, w[1]])

      var shouldShift = vm.chart.data1.length > vm.config.allPoints

      if (vm.config.emgEnabled && emg.length) {
        let shouldShift2 = vm.chart.data3.length >= 200
        for (let i = emg.length - 1; i >= 0; i--) {
          if (shouldShift2) { vm.chart.data3.shift() }
          // vm.chart.data3.shift()
          let t = new Date(lastTime.getTime() - 100 * i)
          vm.chart.data3.push([t, emg[i][0]])
        }
        // console.log(emg.length - 1, 'shifted')
      }

      // vm.chart.data3.push([lastTime, w[2]])
      // vm.chart.data3.shift()

      // vm.chart.history[0].push([lastTime, w[0]])
      // vm.chart.history[1].push([lastTime, w[1]])

      if (vm.disabled) { return 0 }

      if (shouldShift) { vm.chart.data1.shift(); vm.chart.data2.shift() } // vm.chart.data3.shift() işlemi tick2'ye alındı.

      // console.log(vm.chart.data1.length, vm.chart.data2.length, vm.chart.data3.length)

      if (vm.chart.data1.length <= vm.chart.config.invisible_points) { return }

      vm.chart.xAxis.call(vm.chart.x.axis) // redraw x axis

      vm.chart.path1
        .attr('d', vm.chart.line1)

      vm.chart.path2
        .attr('d', vm.chart.line2)

      vm.chart.path3
        .attr('d', vm.chart.line3)

      vm.chart.path3_area
        .attr('d', vm.chart.area3)

      // console.log('-chart.leftTickWidth', -chart.leftTickWidth, '(chart.x(0) - chart.x(chart.tickInterval))', (chart.x(0) - chart.x(chart.tickInterval)))

      vm.chart.pathGroup
      // .attr("transform", null)
        .attr('transform', 'translate(' + (-vm.chart.leftTickWidth) + ',' + 0 + ')')
        .attr('T', 0)

        .interrupt()
      // useful when early-arrive-compensation disabled
      // WHEN USED: if data arrives early, interrupt causes the transition to start from the beginning of next transition
      // WHEN NOT USED: it jumps by tickInterval and transition completes in a duration which was left from previous one

        .transition()
        .duration(vm.chart.tickInterval) // COMPENSATING ADDITION !!!
        .ease('linear')
        .attr('transform', 'translate(' + (vm.chart.x(0) - vm.chart.x(vm.chart.tickInterval)) + ',0)')
        .attr('T', 1)
        .each('end', function () {
          // console.log('>>>>');
          // console.log(chart.config.chartType);
          // console.log('<<<<');

          vm.chart.leftTickWidth = 0
          vm.chart.delayedTicks = 0
          /* vm.$emit('tick', Math.random()*chart.tickInterval); */
        })
      var min = vm.chart.x.domain()[0].getTime() + vm.chart.tickInterval
      var max = vm.chart.x.domain()[1].getTime() + vm.chart.tickInterval
      vm.chart.x.domain([new Date(min), new Date(max)])
    }

    if (!earlyArriveCompensation) {
      return doShifting()
    } else {
      if (parseInt(vm.chart.pathGroup.attr('T')) !== 1) {
        // previous transition did not complete yet

        vm.chart.leftTickWidth = (1 - vm.chart.pathGroup.attr('T')) * ((vm.chart.x(0) - vm.chart.x(vm.chart.tickInterval)) - (-vm.chart.leftTickWidth))
        /*
          from   : -chart.leftTickWidth
          to     : (chart.x(0) - chart.x(chart.tickInterval))
          to-from: (chart.x(0) - chart.x(chart.tickInterval)) - (-chart.leftTickWidth)

          By multiplying interpolated 'T' attribute and (to-from) we found how many shifting left from previous transition. 'T' shows percent (%) of transition
      */

        vm.chart.pathGroup
          .transition()
          .duration(0)
          .each('end', function () { doShifting() })
      // pause previous transition
      } else { doShifting() }
    }
  }
}
/*
export class HelloWorld extends Hello2 {
  constructor() {
    super('World');
  }

  echo() {
    alert(super.hello());
  }
}
*/



// WEBPACK FOOTER //
// ./src/GenericChart.js